// base dropdown events
const GL_DROPDOWN_SHOWN = 'shown';
const GL_DROPDOWN_HIDDEN = 'hidden';
const GL_DROPDOWN_BEFORE_CLOSE = 'beforeClose';
const GL_DROPDOWN_FOCUS_CONTENT = 'focusContent';

// KeyboardEvent.code values
const ARROW_DOWN = 'ArrowDown';
const ARROW_UP = 'ArrowUp';
const END = 'End';
const ENTER = 'Enter';
const HOME = 'Home';
const SPACE = 'Space';

// KeyboardEvent.keyCode values
const KEY_CODE_ESCAPE = 27;

// Positioning strategies
// https://floating-ui.com/docs/computePosition#strategy
const POSITION_ABSOLUTE = 'absolute';
const POSITION_FIXED = 'fixed';
const GL_DROPDOWN_CONTENTS_CLASS = 'gl-new-dropdown-contents';

export { ARROW_DOWN, ARROW_UP, END, ENTER, GL_DROPDOWN_BEFORE_CLOSE, GL_DROPDOWN_CONTENTS_CLASS, GL_DROPDOWN_FOCUS_CONTENT, GL_DROPDOWN_HIDDEN, GL_DROPDOWN_SHOWN, HOME, KEY_CODE_ESCAPE, POSITION_ABSOLUTE, POSITION_FIXED, SPACE };
